import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
export function encodeInteract(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Interact).u32(packet.npcId);
    return writer;
}
export function decodeInteract(reader) {
    return { npcId: reader.u32() };
}
/** Distância máxima, em tiles, para conversar com um NPC. */
export const INTERACT_RANGE = 3;
// --- Loja -------------------------------------------------------------------
export const ShopAction = {
    /** O jogador compra do NPC. */
    Buy: 0,
    /** O jogador vende ao NPC. */
    Sell: 1,
    /** Fecha a janela. O servidor esquece com quem o jogador estava falando. */
    Close: 2,
    /**
     * Conserta tudo que está gasto, de uma vez (PRD §15.7).
     *
     * Uma ação e não uma por peça: o jogador não escolhe consertar só as botas, e um preço por
     * peça faria a janela ter cinco botões que ninguém compara. `typeId` e `count` vêm zerados
     * e são ignorados — é o único caso em que o pacote carrega campos que não usa, e o preço
     * disso é menor que o de um opcode novo para um botão.
     */
    Repair: 3,
};
export function encodeShopRequest(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Shop).u8(packet.action).u16(packet.typeId).u16(packet.count);
    return writer;
}
export function decodeShopRequest(reader) {
    const rawAction = reader.u8();
    // A lista é de ações **reconhecidas**, e o `Buy` é o fallback para o byte desconhecido —
    // um cliente adulterado que mande 200 compra em vez de fazer o servidor adivinhar. Toda
    // ação nova precisa entrar aqui, e a que ficar de fora não vira erro: ela vira uma compra
    // de `typeId` zero que a loja recusa em silêncio, e o botão parece não funcionar.
    const action = rawAction === ShopAction.Sell ||
        rawAction === ShopAction.Close ||
        rawAction === ShopAction.Repair
        ? rawAction
        : ShopAction.Buy;
    return { action, typeId: reader.u16(), count: reader.u16() };
}
/** A categoria cabe na máscara de `ShopPacket.specialty`? Ver `specialtyMask`. */
export function specialtyHas(mask, kind) {
    return (mask & (1 << kind)) !== 0;
}
/** A máscara que representa esta lista de categorias. */
export function specialtyMask(kinds) {
    let mask = 0;
    for (const kind of kinds)
        mask |= 1 << kind;
    return mask;
}
export function encodeShop(packet, writer = new BinaryWriter(128)) {
    writer
        .u8(ServerOp.Shop)
        .u32(packet.npcId)
        .str8(packet.npcName)
        .u16(packet.specialty)
        .u32(packet.repairCost)
        .u16(packet.entries.length);
    for (const entry of packet.entries) {
        writer.u16(entry.typeId).u32(entry.buyPrice).u32(entry.sellPrice);
    }
    return writer;
}
export function decodeShop(reader) {
    const npcId = reader.u32();
    const npcName = reader.str8();
    const specialty = reader.u16();
    const repairCost = reader.u32();
    const count = reader.u16();
    const entries = new Array(count);
    for (let i = 0; i < count; i++) {
        entries[i] = {
            typeId: reader.u16(),
            buyPrice: reader.u32(),
            sellPrice: reader.u32(),
        };
    }
    return { npcId, npcName, specialty, repairCost, entries };
}
// --- Banco ------------------------------------------------------------------
export const BankAction = {
    /** Consulta. Não move nada. */
    Balance: 0,
    Deposit: 1,
    Withdraw: 2,
    Close: 3,
};
export function encodeBankRequest(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Bank).u8(packet.action).u32(packet.amount);
    return writer;
}
export function decodeBankRequest(reader) {
    const rawAction = reader.u8();
    const action = rawAction === BankAction.Deposit ||
        rawAction === BankAction.Withdraw ||
        rawAction === BankAction.Close
        ? rawAction
        : BankAction.Balance;
    return { action, amount: reader.u32() };
}
export function encodeBank(packet, writer = new BinaryWriter(16)) {
    writer.u8(ServerOp.Bank).u8(packet.open ? 1 : 0).f64(packet.balance);
    return writer;
}
export function decodeBank(reader) {
    return { open: reader.u8() !== 0, balance: reader.f64() };
}
//# sourceMappingURL=commerce.js.map